var UsaStates = require('usa-states').UsaStates;
const countryCodes = require('country-codes-list');

const countryNameObject = countryCodes.customList('countryCode', '{countryNameEn}');

export const trim = (value) => {
    // removing the space
    if(value != null && value != "") {
        return value.replace(/^[ \t]+|[ \t]+$/gm, "");
    } else {
        return ""
    }
}

export const getStateList = () => { 
    var usStates = new UsaStates({includeTerritories: false});
    var statesNames = usStates.arrayOf('abbreviation');
    return statesNames;
}

export const getCountryNameArray = () => {
    const countryNameArray = ['United States of America'];
    const countryExcludeAmerica = [];
    Object.keys(countryNameObject).forEach((key) => {
        if(!countryExcludeAmerica.includes(countryNameObject[key]) && countryNameObject[key] !== 'United States of America') {
            countryExcludeAmerica.push(countryNameObject[key]);
        }
    });
    return countryNameArray.concat(countryExcludeAmerica.sort());
}

// Converting UTC to PST
export const convertUTCToPST = (dateString, type) => {
    var date = "";
    var dateObject = new Date(dateString);
    var dateTimezone = new Date(dateObject.toLocaleString('en-US', {
        timeZone: 'America/Los_Angeles'
    }));
    
    if(type == "updates") {
        date = dateTimezone.toLocaleString('en-US', { 
            year: 'numeric',
            month: 'short',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
        });
    } else if(type == "picker") {
        var date = dateTimezone.toLocaleDateString('en-us', { year:"numeric", month:"short", day:"numeric"});
    }

    return date;
}

// Converting date object to date string with specific format
export const convertToDateString = (date, type) => {
    var dateString = "";
    if(type == "picker") {
        dateString = date.toLocaleDateString('en-us', { year:"numeric", month:"short", day:"numeric"});
    } else {
        dateString = date.toLocaleDateString('sv-SE');
    }

    return dateString;
}

export const getCSVData = (data) => {
    let csvdata = new Array();

    data && data.map((item)=> {
        let csvarray = new Array();
        var count = 0;
        const formContent = item.formContent ? JSON.parse(item.formContent) : '';
        
        for (const property in formContent) {
            if(formContent[property].order >= count) {
                count = formContent[property].order;
            } 
            if(property === 'dateSubmitted' || property === 'dateUpdated') {
                formContent[property].value = convertUTCToPST(formContent[property].value, "updates");
            }

            if(property === "businessNameAndAddress") {
                var address = formContent[property].value
                if(address.slice(-2) == ', ') {
                    formContent[property].value = formContent[property].value.slice(0, -2);
                }
            }
        }

        for(var i = -1; i <= count; i++) {
            for(const property in formContent) {
                if(i == formContent[property].order && formContent[property].value != null) {
                    var detail =  `${property.replace( /([A-Z])/g, " $1" ).charAt(0).toUpperCase() + property.replace( /([A-Z])/g, " $1" ).slice(1)}: ${formContent[property].value}`
                    csvarray.push(detail);
                }
            }
        }

        if(csvarray && csvarray.length > 0) {
            csvdata.push(csvarray)
        }
    })

    var downloadArray = new Array();
    for(let i = 0; i < csvdata.length; i++) {
        // Make Text file
        const data = new Blob([csvdata[i].join('\n\n')], {type:'text/plain'})
        downloadArray.push(window.URL.createObjectURL(data));
    }

    return downloadArray
}

export const isURLEncoded = (str) => {
    // Regular expression to match percent-encoded characters
    const encodedPattern = /%[0-9A-Fa-f]{2}/g;
    return encodedPattern.test(str);
}

export const escapeHtml = (str) => {
    // Preserve <strong> and </strong> tags while escaping other tags
    return str.replace(/<[^>]*>/g, (tag) => {
        if (tag === '<strong>' || tag === '</strong>') {
            return tag;
        }
        return tag.replace(/</g, '&lt;').replace(/>/g, '&gt;');
    });
};